<template>
  <form
    class="modal-card"
    style="width: auto"
    @submit.prevent="add"
  >
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        Selecciona Tipo y Monto
      </p>
    </header>

    <section class="modal-card-body">
      <BField label="Tipo de relación:">
        <BSelect
          v-model="type"
          placeholder="Selecciona el tipo:"
          required
        >
          <option value="01">
            Nota de crédito de los documentos relacionados
          </option>
          <option value="03">
            Devolución de mercancía sobre facturas o traslados previos
          </option>
        </BSelect>
      </BField>

      <BField label="Monto">
        <BInput
          v-model="amount"
          :value="amount"
          type="number"
          placeholder="$0.00"
          min="1"
          step="0.01"
          :max="voucherTotal"
          :disabled="type === '03'"
          required
        />
      </BField>

      <BField
        v-if="type === '01'"
        label="Porcentaje"
      >
        <BInput
          v-model="percentage"
          :value="percentage"
          type="number"
          placeholder="1%"
          min="0"
          max="99"
          required
          @input="onChangePercentage"
        />
      </BField>
    </section>

    <footer class="modal-card-foot">
      <button
        class="button"
        type="button"
        @click="$parent.close()"
      >
        Cerrar
      </button>
      <button class="button is-primary">
        Agregar
      </button>
    </footer>
  </form>
</template>

<script>
import merge from 'lodash/merge';

import { mapState, mapMutations } from 'vuex';

import utils from '@/lib/utils';

export default {
  name: 'NewCreditNotePush',
  props: {
    voucherTotal: {
      type: Number,
      default: 0,
    },
    complement: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      amount: this.voucherTotal,
      percentage: 0,
      type: null,
    };
  },
  computed: merge(
    mapState({
      concepts: ({ invoice }) => invoice.concepts,
      cfdisRelated: ({ invoice }) => invoice.cfdisRelated,
    }),
  ),
  watch: {
    voucherTotal(value) {
      this.amount = value;
    },
  },
  methods: merge(
    mapMutations({
      setValue: 'invoice/setValue',
      addCfdiRelated: 'invoice/addCfdiRelated',
      addAmount: 'invoice/addAmount',
      addAmountCfdi: 'invoices/addAmount',
      setInvoicesValue: 'invoices/setValue',
    }),
    {
      onChangePercentage(value) {
        this.amount = utils.fixFloat(this.voucherTotal * (value / 100), 2);
      },
      add() {
        const { uuid } = this.complement.digitalTaxStamp;

        const exists = this.cfdisRelated.some(({ uuids }) => uuids.includes(uuid));

        if (exists) {
          this.$parent.close();

          return;
        }

        const [concept] = this.concepts;

        this.addCfdiRelated({ type: this.type, uuid });

        this.addAmountCfdi({ uuid, amount: this.amount });

        this.addAmount({ uuid, amount: this.amount });

        this.setValue({
          accessor: 'concepts.[0].unit',
          value: parseFloat(concept.unit) + parseFloat(this.amount),
        });

        this.setValue({
          accessor: 'voucherTotal',
          value: parseFloat(concept.unit) + parseFloat(this.amount),
        });

        this.setValue({
          accessor: 'voucherSubTotal',
          value: parseFloat(concept.unit) + parseFloat(this.amount),
        });

        this.$parent.close();
      },
    },
  ),
};
</script>
